import { Link } from "react-router-dom";
import {ImQuotesLeft} from 'react-icons/im'
import AboutImage from '../images/testimonial-three.png';
import { useEffect } from "react";
import '../pages/home/home.css';

const AboutSection = () => {

    return (
        <div className="homeAbout">
            <div className="container home-about-container">
                <div className="home-abt-text-l">
                    <h5>WE ARE</h5> 
                    <h2>The pest control expert you can trust.</h2> 
                    <p>
                        At PestEX Masters, we understand the impact that pests can have on your home or
                        business. Pests such as termites, rodents, bedbugs, and cockroaches can cause extensive damage to
                        property and pose health risks to your family, employees, and customers. That's why we are committed
                        to providing you with safe, reliable, and effective pest control services to protect your property and
                        keep your loved ones or business safe.
                    </p>
                    <span><Link to={"./about"} className="btn lg cta-home-btn">Learn More</Link></span>
                </div>
                <div className="home-abt-img-r">
                    <img src={AboutImage} alt="about-home" />
                    <div className="quote-cont">
                        <span><ImQuotesLeft/></span>
                        <p className="quote">Welcome to PestEX Masters, your trusted partner for effective pest management solutions in Kenya.</p>
                        <br/>
                        {/* <p className="quote-author">- John Doe</p> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutSection